import { CheckoutLayout } from "../../components/checkout/CheckoutLayout"
import PricingPlan from "../../components/pricing plan"

export const ChoosePlan = () => {
    return (
        <CheckoutLayout page="choose_a_plan">
            <PricingPlan/>
        </CheckoutLayout>
        
    )
}